// extracted by mini-css-extract-plugin
export default {"searchContainer":"Zendesk_searchContainer__KLQh5","customPrimaryBtn":"Zendesk_customPrimaryBtn__yx9EA"};